<template>
    <canvas :id="'myChart' + id"></canvas>
 </template>
 
 <script>
 import Chart from 'chart.js/auto';
 import ChartDataLabels from 'chartjs-plugin-datalabels';
 
 export default {
   name: "PassengerTrafficRoadTransport",
   props: {
    receivedData: {
      type: [Object, Array],
      required: true
    },
    graphType: {
      type: [String],
      required: true
    },
    indexAxis: {
      type: String,
      default: 'x'
    },
    id: {
      type: String,
      required: true
    },
    dataLabels: {
      type: Boolean,
      default: false
    },
    maintainAspectRatio: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      type: Number,
      default: 1
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    stacked: {
      type: Boolean,
      default: true
    }
   },

   mounted() {
     const ctx = document.getElementById("myChart" + this.id);
     Chart.register(ChartDataLabels)
    
     const myChart = new Chart(ctx, {
         type: this.graphType,
         data: this.graphicData,
         options: this.options
 
     })
   },

   computed: {
    options () {
      return  {
        indexAxis: this.indexAxis,
        plugins: this.plugins,
        maintainAspectRatio: this.maintainAspectRatio, 
        aspectRatio: 1,
        scales: {
          x: {
            stacked: this.stacked,
          },
          y: {
            stacked: this.stacked
          }
        }
      }
    },
    plugins () {
      return {
        datalabels: {
          align: true,
          display: this.dataLabels,
          textAlign: 'start',
          anchor: 'start',
          font: {
            size: 14,
            weight: 600
          }
        },
        legend: {
          labels: {
            usePointStyle: true,
          },
          position: 'bottom',
        },
        title: {
          display:this.isTitle,
          text: this.receivedData.sub_title != null ? this.receivedData.sub_title :this.receivedData.title,
          font: {
            size: 14
          }
        }
      }
    },

    datasets () {
      return this.getDataset(this.receivedData)
    },
    
    graphicData () {
      return {
        labels: this.finalData.labelsY,
        datasets: this.datasets
      }
    },

    finalData () {
      return this.getFinalData()
    },
   },

   methods: {
    getDataset (data) {
      let newDataSet = []
      let labelsX = data.labels
      labelsX.forEach((item, index) => {
        newDataSet.push({
            label: item.name,
            backgroundColor: item.color,
            borderColor: item.color,
            data: this.finalData.trafficData[index],
          })
      })

      return newDataSet
    },

    getFinalData () {
      let trafficData = this.receivedData.data.sort((a, b) => { 
        if (Number(b.year) > Number(a.year)) {
          return -1
        }
      })

      let newTrafficData = {}
      let labelsY = []
      let labelsX = this.receivedData.labels
 
      labelsX.forEach((item, index) => {
        newTrafficData[index] = []
        trafficData.forEach((itemValue) => {
          let value = itemValue.data.find(val => val.label_id == item.id)
          
          if (value != null) {
            newTrafficData[index].push(value.value)
          }
        })

      })
      
      labelsY = trafficData.reduce((total, value) => {
          total.push(value.year + "")
          return total
      }, [])

      return {
        trafficData: newTrafficData,
        labelsY: labelsY
      }
    },

    getYears () {

    }
   }
 }
 </script>
 
 
 <style scoped>
 .parent_chart{
   width: 50%;
 }

 #myChart {
  width: 500px;
 }
 </style>